module.exports = __webpack_public_path__ + "h5/img/home8.e91827ee.png";